import React, { useState } from 'react';
import axios from 'axios';
import { Upload, X, Image as ImageIcon } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ImageUploader = ({ onUploadComplete, existingImages = [], hideLabel = false, hidePreviewGrid = false, buttonText }) => {
  const [uploading, setUploading] = useState(false);
  const [images, setImages] = useState(existingImages);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    setUploading(true);

    try {
      const uploadPromises = files.map(async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axios.post(`${API_URL}/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        return `${process.env.REACT_APP_BACKEND_URL}${response.data.url}`;
      });

      const uploadedUrls = await Promise.all(uploadPromises);
      const newImages = [...images, ...uploadedUrls];
      setImages(newImages);
      onUploadComplete(newImages);
      toast.success(`${uploadedUrls.length} imagem(ns) enviada(s) com sucesso!`);
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Erro ao enviar imagem');
    } finally {
      setUploading(false);
    }
  };

  const removeImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
    onUploadComplete(newImages);
  };

  return (
    <div>
      {!hideLabel && (
        <label className="font-accent text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
          Imagens do Produto
        </label>
      )}

      {/* Image Preview Grid */}
      {!hidePreviewGrid && images.length > 0 && (
        <div className="grid grid-cols-4 gap-4 mb-4">
          {images.map((url, index) => (
            <div key={`${url}-${index}`} className="relative aspect-square border border-border overflow-hidden group">
              <img src={url} alt={`Imagem ${index + 1}`} className="w-full h-full object-cover" />
              <button
                type="button"
                onClick={() => removeImage(index)}
                className="absolute top-2 right-2 bg-destructive text-white p-1 opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Upload Button */}
      <label
        className={`flex items-center justify-center gap-2 border-2 border-dashed border-border hover:border-primary transition-all duration-300 p-8 cursor-pointer ${
          uploading ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <input
          type="file"
          accept="image/*"
          multiple={!hidePreviewGrid}
          onChange={handleFileChange}
          disabled={uploading}
          className="hidden"
        />
        {uploading ? (
          <span className="text-sm text-muted-foreground">Enviando...</span>
        ) : (
          <>
            <Upload className="w-5 h-5 text-muted-foreground" strokeWidth={1.5} />
            <span className="text-sm text-muted-foreground">
              {buttonText || 'Clique para fazer upload ou arraste imagens aqui'}
            </span>
          </>
        )}
      </label>

      <p className="text-xs text-muted-foreground mt-2">
        Formatos aceitos: JPG, PNG, GIF, WebP (máx. 10MB por imagem)
      </p>
    </div>
  );
};

export default ImageUploader;
